// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// api路径配置
import apiConfig from '../config/api.config'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import $ from 'jquery'
import './assets/style.css'
import './assets/css/globalStyle.css'
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// 引入BootStrap样式.
import 'bootstrap/js/bootstrap.min.js'
import 'bootstrap/css/bootstrap.min.css'
import qs from 'qs'
import './utils/Validate.js'
import ajaxMixin from './utils/responseIntercept'
import beforeRouteLeaveMinxin from '@/router/mixins/index.js'

import html2Pdf from '@/utils/Html2Pdf'

// 引入Axios
import Axios from 'axios'
// 全局过滤器
import * as filters from './filters'
// register global utility filters(循环注册全局过滤器).
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 全局混入mixin
const mixins = [ajaxMixin, beforeRouteLeaveMinxin]
mixins.forEach(key => {
  Vue.mixin(key, mixins[key])
})
// 解决传参问题
Vue.prototype.$qs = qs

Vue.use(ElementUI, { locale })

// 设定基础URL
Axios.defaults.baseURL = apiConfig.baseUrl
// 引入html2Pdf工具
Vue.use(html2Pdf)

// Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use($, VueQuillEditor)
window.vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js